import {
	AppBar,
	Box,
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	FormControl,
	Grid,
	Icon,
	IconButton,
	InputLabel,
	List,
	ListItem,
	ListItemText,
	MenuItem,
	Select,
	SelectChangeEvent,
	TextField,
	Toolbar,
	Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useNavigate, useParams } from "react-router-dom";
import { settings } from "../../../customize/settings";
import { errorHandler } from "../../../error/handler";
import { storeProspect, updateProspect } from "../../../fetch/prospect/prospect";
import { getProspectImageList, removeProspectImage, updateProspectImage, uploadProspectImage } from "../../../fetch/prospectImage";
import { ITipoLotto } from "../../../interfaces/dettaglio/attributes/models";
import { ICategoria, IQualita, IUso } from "../../../interfaces/lotto/attributes/models";
import { IProspect, IProspectImage, IProspectStore, IProspectUpdate } from "../../../interfaces/prospect/models";
import { getJWT } from "../../../lib/jwt";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { endActionToDoAction, messageAction, startActionToDoAction } from "../../../store/ui/actions";

function Store() {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const { prospectId } = useParams();

	const prospects = useAppSelector((state) => state.prospect.items);

	const tipoLottoList = useAppSelector((state) => state.dettaglio_tipoLotto.list);
	const tipoLottoMap = useAppSelector((state) => state.dettaglio_tipoLotto.items);

	const qualitaList = useAppSelector((state) => state.lotto_qualita.list);
	const qualitaMap = useAppSelector((state) => state.lotto_qualita.items);

	const categoriaList = useAppSelector((state) => state.lotto_categoria.list);
	const categoriaMap = useAppSelector((state) => state.lotto_categoria.items);

	const usoList = useAppSelector((state) => state.lotto_uso.list);
	const usoMap = useAppSelector((state) => state.lotto_uso.items);

	const lastActionDone = useAppSelector((state) => state.ui.lastActionDone);

	const [actualProspect, setActualProspect] = useState<IProspect | null>(null);
	const [cliente, setCliente] = useState<string>("");
	const [clienteError, setClienteError] = useState<string | null>(null);
	const [societa, setSocieta] = useState<string>("");
	const [societa1, setSocieta1] = useState<string>("");
	const [stato, setStato] = useState<string>("");
	const [paese, setPaese] = useState<string>("");
	const [citta, setCitta] = useState<string>("");
	const [telefono, setTelefono] = useState<string>("");
	const [website, setWebsite] = useState<string>("");
	const [contatto1, setContatto1] = useState<string>("");
	const [telefono1, setTelefono1] = useState<string>("");
	const [email1, setEmail1] = useState<string>("");
	const [contatto2, setContatto2] = useState<string>("");
	const [telefono2, setTelefono2] = useState<string>("");
	const [email2, setEmail2] = useState<string>("");
	const [contatto3, setContatto3] = useState<string>("");
	const [telefono3, setTelefono3] = useState<string>("");
	const [email3, setEmail3] = useState<string>("");
	const [agente, setAgente] = useState<string>("");
	const [responsabilegemeg, setResponsabilegemeg] = useState<string>("");
	const [idsTipoLotto, setIdsTipoLotto] = useState<string[]>([]);
	const [idsQualita, setIdsQualita] = useState<string[]>([]);
	const [idsCategoria, setIdsCategoria] = useState<string[]>([]);
	const [idsUso, setIdsUso] = useState<string[]>([]);
	const [notaprofilazione, setNotaprofilazione] = useState<string>("");
	const [prospectImages, setProspectImages] = useState<IProspectImage[]>([]);
	const [isImageLoading, setIsImageLoading] = useState<boolean>(false);
	const [selectedImageId, setSelectedImageId] = useState<number | null>(null);
	const [isUploadDialogOpen, setIsUploadDialogOpen] = useState<boolean>(false);
	const [isPreviewDialogOpen, setIsPreviewDialogOpen] = useState<boolean>(false);
	const [imageToDelete, setImageToDelete] = useState<{ type: "persisted"; id: number } | { type: "pending"; index: number } | null>(null);
	const [imageToRename, setImageToRename] = useState<IProspectImage | null>(null);
	const [renameValue, setRenameValue] = useState<string>("");
	const [imagesToUpload, setImagesToUpload] = useState<(File & { preview: string })[]>([]);
	const [dialogImages, setDialogImages] = useState<(File & { preview: string })[]>([]);
	const [previewImageUrl, setPreviewImageUrl] = useState<string>("");
	const [previewImageName, setPreviewImageName] = useState<string>("");

	const [tipoLottoOptions, setTipoLottoOptions] = useState<ITipoLotto[]>([]);
	const [qualitaOptions, setQualitaOptions] = useState<IQualita[]>([]);
	const [categoriaOptions, setCategoriaOptions] = useState<ICategoria[]>([]);
	const [usoOptions, setUsoOptions] = useState<IUso[]>([]);

	const onClienteChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCliente(event.target.value);
	};
	const onSocietaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setSocieta(event.target.value);
	};
	const onSocieta1Change = (event: React.ChangeEvent<HTMLInputElement>) => {
		setSocieta1(event.target.value);
	};
	const onStatoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setStato(event.target.value);
	};
	const onPaeseChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setPaese(event.target.value);
	};
	const onCittaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCitta(event.target.value);
	};
	const onTelefonoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setTelefono(event.target.value);
	};
	const onWebsiteChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setWebsite(event.target.value);
	};
	const onContatto1Change = (event: React.ChangeEvent<HTMLInputElement>) => {
		setContatto1(event.target.value);
	};
	const onTelefono1Change = (event: React.ChangeEvent<HTMLInputElement>) => {
		setTelefono1(event.target.value);
	};
	const onEmail1Change = (event: React.ChangeEvent<HTMLInputElement>) => {
		setEmail1(event.target.value);
	};
	const onContatto2Change = (event: React.ChangeEvent<HTMLInputElement>) => {
		setContatto2(event.target.value);
	};
	const onTelefono2Change = (event: React.ChangeEvent<HTMLInputElement>) => {
		setTelefono2(event.target.value);
	};
	const onEmail2Change = (event: React.ChangeEvent<HTMLInputElement>) => {
		setEmail2(event.target.value);
	};
	const onContatto3Change = (event: React.ChangeEvent<HTMLInputElement>) => {
		setContatto3(event.target.value);
	};
	const onTelefono3Change = (event: React.ChangeEvent<HTMLInputElement>) => {
		setTelefono3(event.target.value);
	};
	const onEmail3Change = (event: React.ChangeEvent<HTMLInputElement>) => {
		setEmail3(event.target.value);
	};
	const onAgenteChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setAgente(event.target.value);
	};
	const onResponsabilegemegChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setResponsabilegemeg(event.target.value);
	};
	const onTipoLottoChange = (event: SelectChangeEvent<string[]>) => {
		const value = event.target.value;
		setIdsTipoLotto(typeof value === "string" ? value.split(",") : value);
	};
	const onQualitaChange = (event: SelectChangeEvent<string[]>) => {
		const value = event.target.value;
		setIdsQualita(typeof value === "string" ? value.split(",") : value);
	};
	const onCategoriaChange = (event: SelectChangeEvent<string[]>) => {
		const value = event.target.value;
		setIdsCategoria(typeof value === "string" ? value.split(",") : value);
	};
	const onUsoChange = (event: SelectChangeEvent<string[]>) => {
		const value = event.target.value;
		setIdsUso(typeof value === "string" ? value.split(",") : value);
	};
	const onNotaprofilazioneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setNotaprofilazione(event.target.value);
	};

	const checkError = (): boolean => {
		let errors = 0;
		if (!cliente) {
			setClienteError('Campo obbligatorio');
			errors++;
		} else {
			setClienteError(null);
		}
		return !!errors;
	}

	const toCsv = (values: string[]): string | null => {
		const normalized = values.filter((item) => !!item).join(",");
		return normalized || null;
	};

	const fromCsv = (value: string | null | undefined): string[] =>
		(value || "")
			.split(",")
			.map((item) => item.trim())
			.filter((item) => !!item);

	const mergeLegacyAndCsv = (
		legacyId: number | null | undefined,
		csvValue: string | null | undefined
	): string[] => {
		const csvIds = fromCsv(csvValue);
		if (!legacyId) return csvIds;
		return [String(legacyId), ...csvIds];
	};

	const renderSelectedNames = (
		selectedIds: string[],
		options: { id: number; nome: string }[]
	): string =>
		selectedIds
			.map((id) => options.find((item) => String(item.id) === id)?.nome || id)
			.join(", ");

	const getProspectData = (): IProspectUpdate => {
		return {
			cliente,
			societa,
			societa1,
			stato,
			paese,
			citta,
			telefono,
			website,
			contatto1,
			telefono1,
			email1,
			contatto2,
			telefono2,
			email2,
			contatto3,
			telefono3,
			email3,
			agente,
			responsabilegemeg,
			idQualita: null,
			idCategoria: null,
			idUso: null,
			idSTipoLotto: toCsv(idsTipoLotto),
			idSQualita	: toCsv(idsQualita),
			idSCategoria: toCsv(idsCategoria),
			idSUso: toCsv(idsUso),
			notaprofilazione
		};
	};

	const submit = async () => {
		if (checkError()) return;
		const data = getProspectData();
		const actionToDo = !!prospectId ? "update-prospect" : "store-prospect";
		try {
			dispatch(startActionToDoAction({ actionToDo }));
			let savedProspectId = actualProspect?.id || null;
			if (!!prospectId && !!savedProspectId) {
				await updateProspect(savedProspectId, data);
			} else {
				const response = await storeProspect(data as IProspectStore);
				savedProspectId = response.id;
			}
			if (!!savedProspectId && !!imagesToUpload.length) {
				await Promise.all(
					imagesToUpload.map((file) =>
						uploadProspectImage({
							idProspect: savedProspectId as number,
							image: file,
							name: file.name
						})
					)
				);
			}
			dispatch(endActionToDoAction({ actionToDo, success: true }));
			dispatch(messageAction({ message: !!prospectId ? "prospect aggiornato" : "prospect aggiunto", kind: "success" }));
			imagesToUpload.forEach((image) => {
				if (image.preview) URL.revokeObjectURL(image.preview);
			});
			setImagesToUpload([]);
			if (!!savedProspectId) await listProspectImages(savedProspectId);
			navigate("..");
		} catch (err) {
			errorHandler(err, actionToDo);
		}
	};

	const back = () => {
		navigate('..');
	}

	const listProspectImages = async (id: number) => {
		const actionToDo = "list-prospect-image";
		try {
			setIsImageLoading(true);
			dispatch(startActionToDoAction({ actionToDo }));
			const { items } = await getProspectImageList(id);
			setProspectImages(items);
			if (!selectedImageId && items.length) setSelectedImageId(items[0].id);
			if (selectedImageId && !items.find((item) => item.id === selectedImageId)) {
				setSelectedImageId(items.length ? items[0].id : null);
			}
			dispatch(endActionToDoAction({ actionToDo, success: true }));
		} catch (err) {
			errorHandler(err, actionToDo);
		} finally {
			setIsImageLoading(false);
		}
	};

	const onProspectImageDelete = async (id: number) => {
		if (!actualProspect?.id) return;
		const actionToDo = "remove-prospect-image";
		try {
			dispatch(startActionToDoAction({ actionToDo }));
			await removeProspectImage(id);
			dispatch(endActionToDoAction({ actionToDo, success: true }));
			dispatch(messageAction({ message: "immagine prospect rimossa", kind: "success" }));
			await listProspectImages(actualProspect.id);
		} catch (err) {
			errorHandler(err, actionToDo);
		}
	};

	const onDeleteConfirmClose = () => {
		setImageToDelete(null);
	};

	const onRenameDialogClose = () => {
		setImageToRename(null);
		setRenameValue("");
	};

	const onRenameDialogSubmit = async () => {
		if (!imageToRename || !actualProspect?.id) return;
		const actionToDo = "rename-prospect-image";
		try {
			dispatch(startActionToDoAction({ actionToDo }));
			await updateProspectImage(imageToRename.id, { name: renameValue || null });
			dispatch(endActionToDoAction({ actionToDo, success: true }));
			dispatch(messageAction({ message: "nome immagine aggiornato", kind: "success" }));
			await listProspectImages(actualProspect.id);
			onRenameDialogClose();
		} catch (err) {
			errorHandler(err, actionToDo);
		}
	};

	const onDeleteConfirmSubmit = async () => {
		if (!imageToDelete) return;
		if (imageToDelete.type === "persisted") {
			await onProspectImageDelete(imageToDelete.id);
		} else {
			setImagesToUpload((prev) => {
				const toDelete = prev[imageToDelete.index];
				if (toDelete?.preview) URL.revokeObjectURL(toDelete.preview);
				return prev.filter((_, index) => index !== imageToDelete.index);
			});
		}
		setImageToDelete(null);
	};

	const getImageUrl = (image: IProspectImage): string => {
		const token = getJWT();
		const tokenQuery = token ? `?token=${token}` : "";
		return `${settings.apiUrl}prospect-image/images/${image.idProspect}/${image.fileName}${tokenQuery}`;
	};

	const selectedImage = selectedImageId ? prospectImages.find((item) => item.id === selectedImageId) || null : null;

	const onOpenSavedImagePreview = (image: IProspectImage) => {
		setSelectedImageId(image.id);
		setPreviewImageUrl(getImageUrl(image));
		setPreviewImageName(image.name || image.fileName || "");
		setIsPreviewDialogOpen(true);
	};

	const onOpenRenameDialog = (image: IProspectImage) => {
		setImageToRename(image);
		setRenameValue(image.name || "");
	};

	const onOpenPendingImagePreview = (image: File & { preview: string }) => {
		setSelectedImageId(null);
		setPreviewImageUrl(image.preview);
		setPreviewImageName(image.name);
		setIsPreviewDialogOpen(true);
	};

	const { getRootProps, getInputProps } = useDropzone({
		multiple: true,
		accept: {
			"image/jpeg": [".jpg", ".jpeg"],
			"image/png": [".png"]
		},
		onDrop: (acceptedFiles) => {
			setDialogImages((prev) => [
				...prev,
				...acceptedFiles.map((file) =>
					Object.assign(file, {
						preview: URL.createObjectURL(file)
					})
				)
			]);
		}
	});

	const closeUploadDialog = () => {
		dialogImages.forEach((image) => {
			if (image.preview) URL.revokeObjectURL(image.preview);
		});
		setDialogImages([]);
		setIsUploadDialogOpen(false);
	};

	const confirmUploadDialog = () => {
		if (!dialogImages.length) {
			closeUploadDialog();
			return;
		}
		setImagesToUpload((prev) => [...prev, ...dialogImages]);
		setDialogImages([]);
		setIsUploadDialogOpen(false);
	};

	useEffect(() => {
		const options: ITipoLotto[] = (!!tipoLottoList && !!tipoLottoMap) ? tipoLottoList.map(item => tipoLottoMap[item]) : []
		setTipoLottoOptions(options);
	}, [tipoLottoList, tipoLottoMap]);
	useEffect(() => {
		const options: IQualita[] = (!!qualitaList && !!qualitaMap) ? qualitaList.map(item => qualitaMap[item]) : []
		setQualitaOptions(options);
	}, [qualitaList, qualitaMap]);
	useEffect(() => {
		const options: ICategoria[] = (!!categoriaList && !!categoriaMap) ? categoriaList.map(item => categoriaMap[item]) : []
		setCategoriaOptions(options);
	}, [categoriaList, categoriaMap]);
	useEffect(() => {
		const options: IUso[] = (!!usoList && !!usoMap) ? usoList.map(item => usoMap[item]) : []
		setUsoOptions(options);
	}, [usoList, usoMap]);
	useEffect(() => {
		if (!!prospectId && !!prospects) setActualProspect(prospects[parseInt(prospectId)] || null)
	}, [prospectId, prospects])
	useEffect(() => {
		if (!!actualProspect) {
			if (!!actualProspect.cliente) setCliente(actualProspect.cliente);
			if (!!actualProspect.societa) setSocieta(actualProspect.societa);
			if (!!actualProspect.societa1) setSocieta1(actualProspect.societa1);
			if (!!actualProspect.stato) setStato(actualProspect.stato);
			if (!!actualProspect.paese) setPaese(actualProspect.paese);
			if (!!actualProspect.citta) setCitta(actualProspect.citta);
			if (!!actualProspect.telefono) setTelefono(actualProspect.telefono);
			if (!!actualProspect.website) setWebsite(actualProspect.website);
			if (!!actualProspect.contatto1) setContatto1(actualProspect.contatto1);
			if (!!actualProspect.telefono1) setTelefono1(actualProspect.telefono1);
			if (!!actualProspect.email1) setEmail1(actualProspect.email1);
			if (!!actualProspect.contatto2) setContatto2(actualProspect.contatto2);
			if (!!actualProspect.telefono2) setTelefono2(actualProspect.telefono2);
			if (!!actualProspect.email2) setEmail2(actualProspect.email2);
			if (!!actualProspect.contatto3) setContatto3(actualProspect.contatto3);
			if (!!actualProspect.telefono3) setTelefono3(actualProspect.telefono3);
			if (!!actualProspect.email3) setEmail3(actualProspect.email3);
			if (!!actualProspect.agente) setAgente(actualProspect.agente);
			if (!!actualProspect.responsabilegemeg) setResponsabilegemeg(actualProspect.responsabilegemeg);
			setIdsTipoLotto(fromCsv(actualProspect.idSTipoLotto));
			setIdsQualita(mergeLegacyAndCsv(actualProspect.idQualita, actualProspect.idSQualita));
			setIdsCategoria(mergeLegacyAndCsv(actualProspect.idCategoria, actualProspect.idSCategoria));
			setIdsUso(mergeLegacyAndCsv(actualProspect.idUso, actualProspect.idSUso));
			if (!!actualProspect.notaprofilazione) setNotaprofilazione(actualProspect.notaprofilazione);
		}
	}, [actualProspect])
	useEffect(() => {
		if (actualProspect?.id) listProspectImages(actualProspect.id);
		else {
			setProspectImages([]);
			setSelectedImageId(null);
		}
	}, [actualProspect?.id]);
	useEffect(() => {
		return () => {
			imagesToUpload.forEach((image) => {
				if (image.preview) URL.revokeObjectURL(image.preview);
			});
			dialogImages.forEach((image) => {
				if (image.preview) URL.revokeObjectURL(image.preview);
			});
		};
	}, []);
	return (
		<Box sx={{ display: "flex", flexDirection: "column", flex: 1, backgroundColor: "#fff" }}>
			<Box sx={{ flex: 1, position: "relative" }}>
				<Box sx={{ backgroundColor: "#fff", boxSizing: "border-box", display: 'flex', position: "absolute", height: "100%", width: "100%", overflowY: "auto" }}>
					<Grid container sx={{ flex: 1, p: 0 }}>
						<Grid item xs={6} sx={{ display: "flex", flexDirection: "column", boxSizing: "border-box", position: "relative", px: 1, pb: 1 }}>
							<Box sx={{ px: 1 }} ><Typography variant="overline">Anagrafica</Typography></Box>
							<Box sx={{ flex: 1, position: "relative" }}>
								<Box sx={{ boxSizing: "border-box", position: "absolute", height: "100%", width: "100%", overflowY: "auto", border: '1px solid #cdcdcd', borderRadius: 1 }}>
									<Box sx={{ display: 'flex', flexDirection: 'column', p: 1 }}>
										<TextField
											required={true}
											margin="dense"
											label="Cliente"
											type="text"
											error={!!clienteError}
											helperText={clienteError}
											value={cliente}
											onChange={onClienteChange}
										/>
										<TextField
											margin="dense"
											label="Società"
											type="text"
											value={societa}
											onChange={onSocietaChange}
										/>
										<TextField
											margin="dense"
											label="Società 1"
											type="text"
											value={societa1}
											onChange={onSocieta1Change}
										/>
										<TextField
											margin="dense"
											label="Stato"
											type="text"
											value={stato}
											onChange={onStatoChange}
										/>
										<TextField
											margin="dense"
											label="Paese"
											type="text"
											value={paese}
											onChange={onPaeseChange}
										/>
										<TextField
											margin="dense"
											label="Città"
											type="text"
											value={citta}
											onChange={onCittaChange}
										/>
										<TextField
											margin="dense"
											label="Telefono"
											type="text"
											value={telefono}
											onChange={onTelefonoChange}
										/>
										<TextField
											margin="dense"
											label="Website"
											type="text"
											value={website}
											onChange={onWebsiteChange}
										/>
										<TextField
											margin="dense"
											label="Contatto 1"
											type="text"
											value={contatto1}
											onChange={onContatto1Change}
										/>
										<TextField
											margin="dense"
											label="Telefono 1"
											type="text"
											value={telefono1}
											onChange={onTelefono1Change}
										/>
										<TextField
											margin="dense"
											label="Email 1"
											type="text"
											value={email1}
											onChange={onEmail1Change}
										/>
										<TextField
											margin="dense"
											label="Contatto 2"
											type="text"
											value={contatto2}
											onChange={onContatto2Change}
										/>
										<TextField
											margin="dense"
											label="Telefono 2"
											type="text"
											value={telefono2}
											onChange={onTelefono2Change}
										/>
										<TextField
											margin="dense"
											label="Email 2"
											type="text"
											value={email2}
											onChange={onEmail2Change}
										/>
										<TextField
											margin="dense"
											label="Contatto 3"
											type="text"
											value={contatto3}
											onChange={onContatto3Change}
										/>
										<TextField
											margin="dense"
											label="Telefono 3"
											type="text"
											value={telefono3}
											onChange={onTelefono3Change}
										/>
										<TextField
											margin="dense"
											label="Email 3"
											type="text"
											value={email3}
											onChange={onEmail3Change}
										/>
										<TextField
											margin="dense"
											label="Agente"
											type="text"
											value={agente}
											onChange={onAgenteChange}
										/>
										<TextField
											margin="dense"
											label="Responsabile Gemeg"
											type="text"
											value={responsabilegemeg}
											onChange={onResponsabilegemegChange}
										/>
									</Box>
								</Box>
							</Box>
						</Grid>
						<Grid item xs={6} sx={{ display: "flex", flexDirection: "column", boxSizing: "border-box", position: "relative", px: 1, pb: 1 }}>
							<Box sx={{ px: 1 }} ><Typography variant="overline">profilo commerciale</Typography></Box>
							<Box sx={{ flex: 1, position: "relative" }}>
								<Box sx={{ boxSizing: "border-box", position: "absolute", height: "100%", width: "100%", overflowY: "auto", border: '1px solid #cdcdcd', borderRadius: 1 }}>
									<Box sx={{ display: 'flex', flexDirection: 'column', p: 1 }}>
										<FormControl fullWidth sx={{ mt: 1, mb: 0.5 }}>
											<InputLabel id="tipo_lotto_label">Tipo</InputLabel>
											<Select
												labelId="tipo_lotto_label"
												id="tipo_lotto_select"
												multiple
												value={idsTipoLotto}
												label="Tipo"
												onChange={onTipoLottoChange}
												renderValue={(selected) => renderSelectedNames(selected as string[], tipoLottoOptions)}
											>
												{tipoLottoOptions.map((item) => (<MenuItem key={String(item.id)} value={String(item.id)}>{item.nome}</MenuItem>))}
											</Select>
										</FormControl>
										<FormControl fullWidth sx={{ mt: 1, mb: 0.5 }}>
											<InputLabel id="qualita_label">Qualità</InputLabel>
											<Select
												labelId="qualita_label"
												id="qualita_select"
													multiple
													value={idsQualita}
												label="Qualità"
													onChange={onQualitaChange}
													renderValue={(selected) => renderSelectedNames(selected as string[], qualitaOptions)}
											>
													{qualitaOptions.map((item) => (<MenuItem key={String(item.id)} value={String(item.id)}>{item.nome}</MenuItem>))}
											</Select>
										</FormControl>
										<FormControl fullWidth sx={{ mt: 1, mb: 0.5 }}>
											<InputLabel id="categoria_label">Categoria</InputLabel>
											<Select
												labelId="categoria_label"
												id="categoria_select"
													multiple
													value={idsCategoria}
												label="Categoria"
													onChange={onCategoriaChange}
													renderValue={(selected) => renderSelectedNames(selected as string[], categoriaOptions)}
											>
													{categoriaOptions.map((item) => (<MenuItem key={String(item.id)} value={String(item.id)}>{item.nome}</MenuItem>))}
											</Select>
										</FormControl>
										<FormControl fullWidth sx={{ mt: 1, mb: 0.5 }}>
											<InputLabel id="uso_label">Uso</InputLabel>
											<Select
												labelId="uso_label"
												id="uso_select"
													multiple
													value={idsUso}
												label="Uso"
													onChange={onUsoChange}
													renderValue={(selected) => renderSelectedNames(selected as string[], usoOptions)}
											>
													{usoOptions.map((item) => (<MenuItem key={String(item.id)} value={String(item.id)}>{item.nome}</MenuItem>))}
											</Select>
										</FormControl>
										<TextField
											margin="dense"
											label="Nota di profilazione"
											type="text"
											multiline
											rows={4}
											value={notaprofilazione}
											onChange={onNotaprofilazioneChange}
											fullWidth
										/>
										<Box sx={{ mt: 2, borderTop: "1px solid #e0e0e0", pt: 2 }}>
											<Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
												<Typography variant="subtitle2">
													Immagini Prospect
												</Typography>
												<IconButton size="small" onClick={() => setIsUploadDialogOpen(true)}>
													<Icon className="fa-light fa-plus" sx={{ overflow: "visible" }} />
												</IconButton>
											</Box>
											{isImageLoading && <CircularProgress size={20} />}
											<Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, pb: 0.5 }}>
												{prospectImages.map((image) => (
													<Box key={image.id} sx={{ width: 200 }}>
														<Box
															sx={{
																position: "relative",
																width: 200,
																height: 200,
																border: image.id === selectedImageId ? "2px solid #1976d2" : "1px solid #e0e0e0",
																borderRadius: 1,
																cursor: "pointer",
																overflow: "hidden"
															}}
															onClick={() => onOpenSavedImagePreview(image)}
														>
														<Box
															component="img"
															src={getImageUrl(image)}
															alt={image.name || image.fileName}
															sx={{ width: "100%", height: "100%", objectFit: "cover" }}
														/>
														<IconButton
															size="small"
															onClick={(event) => {
																event.stopPropagation();
																onOpenRenameDialog(image);
															}}
															sx={{
																position: "absolute",
																top: 2,
																left: 2,
																bgcolor: "rgba(255,255,255,.8)"
															}}
														>
															<Icon className="fa-light fa-pen" sx={{ fontSize: 14, overflow: "visible" }} />
														</IconButton>
														<IconButton
															size="small"
															onClick={(event) => {
																event.stopPropagation();
																setImageToDelete({ type: "persisted", id: image.id });
															}}
															sx={{
																position: "absolute",
																top: 2,
																right: 2,
																bgcolor: "rgba(255,255,255,.8)"
															}}
														>
															<Icon className="fa-light fa-trash-can" sx={{ fontSize: 14, overflow: "visible" }} />
														</IconButton>
														</Box>
														<Typography
															variant="caption"
															sx={{ display: "block", mt: 0.5, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
															title={image.name || image.fileName}
														>
															{image.name || image.fileName}
														</Typography>
													</Box>
												))}
												{imagesToUpload.map((image, index) => (
													<Box key={`${image.name}-${image.lastModified}-${index}`} sx={{ width: 200 }}>
														<Box
															sx={{
																position: "relative",
																width: 200,
																height: 200,
																border: "1px dashed #90caf9",
																borderRadius: 1,
																cursor: "pointer",
																overflow: "hidden"
															}}
															onClick={() => onOpenPendingImagePreview(image)}
														>
														<Box
															component="img"
															src={image.preview}
															alt={image.name}
															sx={{ width: "100%", height: "100%", objectFit: "cover" }}
														/>
														<IconButton
															size="small"
															onClick={(event) => {
																event.stopPropagation();
																setImageToDelete({ type: "pending", index });
															}}
															sx={{
																position: "absolute",
																top: 2,
																right: 2,
																bgcolor: "rgba(255,255,255,.8)"
															}}
														>
															<Icon className="fa-light fa-trash-can" sx={{ fontSize: 14, overflow: "visible" }} />
														</IconButton>
														</Box>
														<Typography
															variant="caption"
															sx={{ display: "block", mt: 0.5, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
															title={image.name}
														>
															{image.name}
														</Typography>
													</Box>
												))}
											</Box>
											{!!imagesToUpload.length && (
												<Typography variant="caption" color="text.secondary">
													{imagesToUpload.length} immagine/i in coda: verranno caricate al Salva.
												</Typography>
											)}
										</Box>
									</Box>
								</Box>
							</Box>
						</Grid>
					</Grid>
				</Box>
			</Box>
			<Box sx={{ display: "flex", justifyContent: "flex-end", padding: 2, border: "1px solid rgba(224, 224, 224, 1)" }}>
				<Button onClick={back} >Cancella</Button>
				<Button variant="contained" onClick={submit}>Salva</Button>
			</Box>
			<Dialog open={isUploadDialogOpen} fullWidth maxWidth="md" onClose={closeUploadDialog}>
				<AppBar color="transparent" sx={{ boxShadow: "none" }}>
					<Toolbar variant="dense">
						<Box sx={{ flex: 1 }} />
						<IconButton edge="end" color="primary" onClick={closeUploadDialog} aria-label="close">
							<Icon className="fa-light fa-xmark" sx={{ overflow: "visible" }} />
						</IconButton>
					</Toolbar>
				</AppBar>
				<Box sx={{ p: 2 }}>
					<Box
						sx={{
							border: "1px dotted grey",
							boxSizing: "border-box",
							p: 1,
							height: 100,
							display: "flex",
							justifyContent: "center",
							alignItems: "center"
						}}
						{...getRootProps({})}
					>
						<input {...getInputProps({ multiple: true })} />
						<Typography>Trascina qua le tue immagini o clicca per selezionarle dal tuo archivio</Typography>
					</Box>
					<List dense>
						{dialogImages.map((file, index) => (
							<ListItem key={`${file.name}-${file.lastModified}-${index}`}>
								<Box component="img" src={file.preview} alt={file.name} sx={{ width: 64, height: 64, objectFit: "cover", mr: 1 }} />
								<ListItemText primary={file.name} secondary={`${file.size} bytes`} />
							</ListItem>
						))}
					</List>
				</Box>
				<DialogActions>
					<Button variant="outlined" onClick={closeUploadDialog}>Cancella</Button>
					<Button variant="contained" onClick={confirmUploadDialog}>Upload</Button>
				</DialogActions>
			</Dialog>
			<Dialog fullScreen open={isPreviewDialogOpen} onClose={() => setIsPreviewDialogOpen(false)}>
				<AppBar position="absolute" color="transparent" sx={{ boxShadow: "none" }}>
					<Toolbar variant="dense">
						<Box sx={{ flex: 1 }} />
						<IconButton edge="end" color="inherit" onClick={() => setIsPreviewDialogOpen(false)} aria-label="close">
							<Icon className="fa-light fa-xmark" sx={{ overflow: "visible" }} />
						</IconButton>
					</Toolbar>
				</AppBar>
				<Box sx={{ p: 1, boxSizing: "border-box", flex: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
					{!!previewImageUrl && (
						<img
							src={previewImageUrl}
							alt={previewImageName}
							loading="lazy"
							style={{ maxWidth: "100%", maxHeight: "95vh", objectFit: "contain" }}
						/>
					)}
				</Box>
			</Dialog>
			<Dialog open={!!imageToDelete} onClose={onDeleteConfirmClose} fullWidth maxWidth="sm">
				<AppBar sx={{ position: "relative" }}>
					<Toolbar variant="dense">
						<Typography variant="h6" sx={{ flex: 1 }}>Elimina immagine</Typography>
					</Toolbar>
				</AppBar>
				<Box sx={{ p: 2 }}>
					<Typography>Sei sicuro di voler eliminare questa immagine?</Typography>
				</Box>
				<DialogActions>
					<Button onClick={onDeleteConfirmClose}>Cancella</Button>
					<Button variant="contained" color="error" onClick={onDeleteConfirmSubmit}>Elimina</Button>
				</DialogActions>
			</Dialog>
			<Dialog open={!!imageToRename} onClose={onRenameDialogClose} fullWidth maxWidth="sm">
				<AppBar sx={{ position: "relative" }}>
					<Toolbar variant="dense">
						<Typography variant="h6" sx={{ flex: 1 }}>Rinomina immagine</Typography>
					</Toolbar>
				</AppBar>
				<Box sx={{ p: 2 }}>
					<TextField
						autoFocus
						fullWidth
						label="Nome immagine"
						value={renameValue}
						onChange={(event) => setRenameValue(event.target.value)}
					/>
				</Box>
				<DialogActions>
					<Button onClick={onRenameDialogClose}>Cancella</Button>
					<Button variant="contained" onClick={onRenameDialogSubmit}>Salva</Button>
				</DialogActions>
			</Dialog>
		</Box >
	)
}

export default Store;
